@if (visible) {
  <span class="founding-badge"
        [class.founding-badge--compact]="compact"
        [class.founding-badge--practitioner]="kind === 'practitioner'"
        *translate="let t"
        [title]="tooltip(t)" [attr.aria-label]="tooltip(t)">
    <span class="founding-badge__mark" aria-hidden="true">🐺</span>
    @if (!compact) {
      <span class="founding-badge__label">{{ t(i18nScope + '.badge') }}</span>
    }
  </span>
}
